import { useIntl } from '@leagueplatform/locales';
import {
  GDSHTMLTagOptions,
  Image,
  ParagraphText,
  StackItem,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { StepScreen } from 'components/step-screen/step-screen.component';
import AccountSetupSuccessIconMyHealth from 'assets/my-health/account-setup-success.png';
import { STEP_STRING_IDS } from 'components/onboarding-account-setup/onboarding-account-setup.constants';
import { useNavigate } from 'react-router-dom';

export const MyHealthCompleteStep = ({
  onComplete,
}: {
  onComplete: () => void;
}) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const BodyTextHtmlTagOptions: GDSHTMLTagOptions = {
    p: {
      component: UtilityText,
      props: {
        emphasis: 'emphasized',
      },
    },
    li: {
      component: UtilityText,
      props: {
        as: 'li',
        emphasis: 'subtle',
      },
    },
  };

  return (
    <StepScreen
      headerContent={
        <Image src={AccountSetupSuccessIconMyHealth} width="160" height="160" />
      }
      heading={formatMessage({ id: STEP_STRING_IDS.complete.heading })}
      subHeading={formatMessage({ id: STEP_STRING_IDS.complete.subHeading })}
      primaryButton={{
        label: formatMessage({
          id: STEP_STRING_IDS.complete.primaryButtonLabel,
        }),
        onClick: () => {
          onComplete();
          navigate('/link-centre');
        },
      }}
      secondaryButton={{
        label: formatMessage({
          id: STEP_STRING_IDS.complete.secondaryButtonLabel,
        }),
        onClick: () => {
          onComplete();
          navigate('/home');
        },
      }}
    >
      <ParagraphText
        as={StackItem}
        htmlStringOptions={BodyTextHtmlTagOptions}
        css={{ gap: '$half', marginBlockEnd: '$none !important' }}
      >
        {formatMessage({ id: STEP_STRING_IDS.complete.body })}
      </ParagraphText>
    </StepScreen>
  );
};
